import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';

type FilterComponentProps = {
  ProductTypeSelect: Record<string, never>;
  LocationSelect: { initialLocation?: StateAbbreviation };
  TermLengthSelect: Record<string, never>;
  MinDepositSelect: Record<string, never>;
  MinBalanceSelect: Record<string, never>;
  BonusSelect: Record<string, never>;
};

export interface FilterConfig {
  filters: Array<{ component: keyof FilterComponentProps }>;
}

export const FILTER_CONFIGS: Record<string, FilterConfig> = {
  'cd-rates': {
    filters: [{ component: 'TermLengthSelect' }, { component: 'MinDepositSelect' }],
  },
  'bank-bonuses-and-promotions': {
    filters: [{ component: 'ProductTypeSelect' }, { component: 'LocationSelect' }],
  },
  'high-yield-online-savings-account': {
    filters: [{ component: 'MinBalanceSelect' }, { component: 'BonusSelect' }],
  },
};

export const getFilterConfig = (slug: string): FilterConfig => {
  return FILTER_CONFIGS[slug] ?? { filters: [] };
};

export const getFiltersForPage = (
  slug: string,
  isGeoTargeted: boolean,
): Array<{ component: keyof FilterComponentProps }> => {
  const config = FILTER_CONFIGS[slug];

  // No config but geo-targeted? Return just LocationSelect
  if (!config && isGeoTargeted) {
    return [{ component: 'LocationSelect' }];
  }

  // No config and not geo-targeted? No filters
  if (!config) return [];

  const baseFilters = config.filters;

  // If geo-targeted AND doesn't already have LocationSelect, append it
  if (isGeoTargeted) {
    const hasLocationFilter = baseFilters.some(f => f.component === 'LocationSelect');
    if (!hasLocationFilter) {
      return [...baseFilters, { component: 'LocationSelect' }];
    }
  }

  return baseFilters;
};
